<template>
  <div>
    <el-tabs
    type="border-card"
    v-model="activeName"
    >
      <el-tab-pane
      label="查询"
      name="one"
      >
        <!-- 查询表单 -->
        <el-form
        ref="user_form"
        :model="user_form"
        label-width="80px"
        style="margin-bottom: 50px;"
        class="user_form"
        >
          <el-form-item label="关键字" prop="key">
            <el-input v-model="user_form.key" placeholder="用户名/昵称"></el-input>
          </el-form-item>
          <el-form-item label="所属公司" prop="companyId">
            <el-select style="width: 100%;" :popper-append-to-body="false" @change="company_change" v-model="user_form.companyId">
              <el-option v-for="item in company_list" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属部门" prop="departmentId">
            <el-select clearable style="width: 100%;" :popper-append-to-body="false" v-model="user_form.departmentId">
              <el-option v-for="item in department_list" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户状态" prop="userStatus">
            <el-select clearable style="width: 100%;" :popper-append-to-body="false" v-model="user_form.userStatus">
              <el-option label="已启用" value="1"></el-option>
              <el-option label="已禁用" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
            type="primary"
            @click="search_list()"
            v-if="btn_permission.includes('sys:userAuth:list')||btn_permission.includes('superAdmin')"
            >查询</el-button>
            <el-button
            v-if="btn_permission.includes('sys:userAuth:list')||btn_permission.includes('superAdmin')"
            @click="reset_form()">重置</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
      label="用户列表"
      name="two"
      >
        <el-table
        :data="listData"
        highlight-current-row
        max-height="500"
        border
        ref="query_check_detail"
        @row-dblclick="query_check_detail"
        >
          <el-table-column type="index" align="center" label="id"></el-table-column>
          <el-table-column prop="userName" label="用户名"></el-table-column>
          <el-table-column prop="nickName" label="姓名"></el-table-column>
          <el-table-column label="用户状态">
            <template slot-scope="scope">
              <span>{{scope.row.status==0?'已禁用':'已启用'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="注册时间"></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-tag
              class="operate"
              effect="dark"
              type="warning"
              v-if="btn_permission.includes('sys:user:resetPwd')||btn_permission.includes('superAdmin')"
              @click="reset_password(scope.row)"
              >
                重置密码
              </el-tag>
              <el-tag
              class="operate"
              effect="dark"
              type="success"
              v-if="scope.row.status==0&&btn_permission.includes('sys:user:active')||
              scope.row.status==0&&btn_permission.includes('superAdmin')"
              @click="open_close(scope.row)"
              >启用</el-tag>
              <el-tag
              class="operate"
              effect="dark"
              type="danger"
              v-if="scope.row.status==1&&btn_permission.includes('sys:user:disable')||
              scope.row.status==1&&btn_permission.includes('superAdmin')"
              @click="open_close(scope.row)"
              >禁用</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <!-- 用户列表分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="pageparm_size_change"
        @current-change="pageparm_current_change"
        :current-page="pageparm.currentPage"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pageparm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageparm.total"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane
      label="明细"
      name="three"
      class="el_details_row"
      >
        <!-- 用户列表明细 -->
        <el-table
        :data="listData"
        highlight-current-row
        border
        max-height="400"
        ref="db_detail_list"
        class="db_detail_list"
        @row-dblclick="db_detail_list"
        >
          <el-table-column
          align="center"
          prop="userName"
          label="用户名"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="nickName"
          label="姓名"
          ></el-table-column>
          <el-table-column label="用户状态">
            <template slot-scope="scope">
              <span>{{scope.row.status==0?'已禁用':'已启用'}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-tabs
        type="card"
        v-model="detail_active"
        class="detail_tabs"
        >
          <el-tab-pane
          label="授权信息"
          name="first"
          >
            <!-- 授权信息列表 -->
            <el-divider content-position="left">列表</el-divider>
            <el-table
            highlight-current-row
            :data="author_data"
            border
            max-height="400"
            ref="db_author_list"
            @row-dblclick="db_author_list"
            >
              <el-table-column
              width="80px"
              align="center"
              type="index"
              label="序号"
              ></el-table-column>
              <el-table-column
              align="center"
              prop="dataWarehouseTypeText"
              label="所属数据仓"
              ></el-table-column>
              <el-table-column
              align="center"
              prop="createTime"
              label="创建时间"
              ></el-table-column>
            </el-table>
            <!-- 授权信息列表分页 -->
            <!-- <el-pagination
            style="margin: 10px auto;"
            background
            @size-change="author_size_change"
            @current-change="author_current_change"
            :current-page="author_current_page"
            :page-sizes="[10,15,20,25]"
            :page-size="author_page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="author_total"
            ></el-pagination> -->
            <!-- 授权信息表单 -->
            <el-divider content-position="left">操作表单</el-divider>
            <el-form
            ref="auth_form"
            :model="auth_form"
            label-width="100px"
            class="auth_form"
            :rules="rules"
            >
              <el-form-item label="用户名">
                <el-input :readonly="true" v-model="userName"></el-input>
              </el-form-item>
              <el-form-item label="昵称">
                <el-input :readonly="true" v-model="nickName"></el-input>
              </el-form-item>
              <el-form-item label="所属数据仓" prop="dataWarehouseType">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="false"
                v-model="auth_form.dataWarehouseType"
                placeholder="请选择"
                @change="dataWarehouseType_change"
                clearable
                :disabled="dataWarehouse_status"
                >
                  <el-option
                  v-for="item in dataWarehouseType_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属公司" prop="companyId">
                <el-select
                v-model="auth_form.companyId"
                style="width: 100%;"
                placeholder="请选择公司"
                :popper-append-to-body="false"
                @change="company_change"
                filterable
                clearable
                >
                  <el-option
                  v-for="item in company_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属部门" prop="departmentId">
                <el-select
                v-model="auth_form.departmentId"
                style="width: 100%;"
                placeholder="请选择部门"
                :popper-append-to-body="false"
                filterable
                clearable
                >
                  <el-option
                  v-for="item in department_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="用户类型" prop="utype">
                <el-select
                v-model="auth_form.utype"
                style="width: 100%;"
                placeholder="请选择用户类型"
                :popper-append-to-body="false"
                filterable
                clearable
                >
                  <el-option
                  v-for="item in utype_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货主" prop="customerIds">
                <el-select
                multiple
                collapse-tags
                v-model="auth_form.customerIds"
                style="width: 100%;"
                placeholder="请选择货主"
                :popper-append-to-body="false"
                filterable
                >
                  <el-option
                  v-for="item in customer_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="仓库" prop="wareHouseIds">
                <el-select
                multiple
                collapse-tags
                v-model="auth_form.wareHouseIds"
                style="width: 100%;"
                placeholder="请选择仓库"
                :popper-append-to-body="false"
                filterable
                >
                  <el-option
                  v-for="item in wareHouse_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="角色" prop="roleIds">
                <el-select
                multiple
                collapse-tags
                v-model="auth_form.roleIds"
                style="width: 100%;"
                placeholder="请选择角色"
                :popper-append-to-body="false"
                filterable
                >
                  <el-option
                  v-for="item in role_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="默认仓库" prop="defaultUse">
                <el-switch
                v-model="auth_form.defaultUse"
                active-color="#13ce66"
                inactive-color="#ff4949"
                ></el-switch>
              </el-form-item>
              <el-form-item label="是否授权" prop="authStatus">
                <el-switch
                v-model="auth_form.authStatus"
                active-color="#13ce66"
                inactive-color="#ff4949"
                ></el-switch>
              </el-form-item>
              <el-form-item class="el-row">
                <el-button
                type="primary"
                :disabled="add_auth_status"
                @click="add_auth()"
                v-if="btn_permission.includes('sys:userAuth:add')||btn_permission.includes('superAdmin')"
                >新增</el-button>
                <el-button
                type="success"
                :disabled="edit_auth_status"
                @click="edit_auth()"
                v-if="btn_permission.includes('sys:userAuth:edit')||btn_permission.includes('superAdmin')"
                >修改</el-button>
                <el-button
                @click="save_auth()"
                :disabled="save_auth_status"
                >保存</el-button>
                <el-button
                :disabled="cancel_auth_status"
                @click="reset_auth()">取消</el-button>
                <el-button
                type="danger"
                :disabled="delete_auth_status"
                @click="delete_auth()"
                v-if="btn_permission.includes('sys:userAuth:del')||btn_permission.includes('superAdmin')"
                >删除</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Pagination from '../Pagination'
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        activeName:'one',
        //用户列表
        listData:[],
        //用户列表分页
        pageparm:{
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        //用户列表查询表单
        user_form:{
          key:'',
          companyId:'',
          departmentId:'',
          userStatus:''
        },
        //用户所属公司
        company_list:[],
        //用户所属部门
        department_list:[],
        //用户类型
        utype_list:[],
        //用户货主
        customer_list:[],
        //用户仓库
        wareHouse_list:[],
        //所属数据仓下拉列表
        dataWarehouseType_list:[],
        //角色列表
        role_list:[],
        //用户管理当前行数据
        row_query_now:{},
        //明细tab切换
        detail_active:'first',
        //用户ID
        user_id:'',
        userName:'',
        nickName:'',
        //新增或修改授权信息判断条件
        add_or_edit:'',
        //授权信息列表
        author_data:[],
        //授权信息当前行
        row_auth_now:{},
        //授权信息列表分页
        author_current_page:1,
        author_page_size:10,
        author_total:10,
        //用户授权提交表单
        auth_form:{
          companyId:'',
          departmentId:'',
          utype:'',
          customerIds:[],
          wareHouseIds:[],
          roleIds:[],
          dataWarehouseType:'',
          defaultUse:true,
          authStatus:true
        },
        //用户授权表单禁用启用状态
        dataWarehouse_status:false,
        add_auth_status:false,
        edit_auth_status:false,
        delete_auth_status:false,
        save_auth_status:true,
        cancel_auth_status:true,
        //表单验证
        rules:{
          dataWarehouseType:[
            {required:true,message:'请选择所属数据仓',trigger:'change'}
          ],
          companyId:[
            {required:true,message:'请选择所属公司',trigger:'change'}
          ],
          departmentId:[
            {required:true,message:'请选择所属部门',trigger:'change'}
          ],
          utype:[
            {required:true,message:'请选择用户类型',trigger:'change'}
          ],
          roleIds:[
            {required:true,message:'请选择角色',trigger:'change'}
          ]
        }
      }
    },
    //注册组件
    components:{
      Pagination
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //所属数据仓下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/byCode/dataWarehouseType'
      }).then(data=>{
        if(data.data.success==true){
          that.dataWarehouseType_list=data.data.data
          that.auth_form.dataWarehouseType=that.dataWarehouseType_list[0].value

        }
      })
      //用户所属公司
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/company'
      }).then(data=>{
        if(data.data.success==true){
          that.company_list=data.data.data
        }else{
          // that.$message.error(data.data.message)
        }
      })
      //用户类型
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/uType'
      }).then(data=>{
        if(data.data.success==true){
          that.utype_list=data.data.data
        }else{
          // that.$message.error(data.data.message)
        }
      })
      //角色列表
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/role/select'
      }).then(data=>{
        if(data.data.success==true){
          that.role_list=data.data.data
        }else{
          // that.$message.error(data.data.message)
        }
      })
      //用户列表
      that.user_list()
    },
    mounted() {

    },
    methods:{
      //用户列表分页
      pageparm_size_change(val){
        this.pageparm.pageSize=val
        //用户列表
        this.user_list()
      },
      pageparm_current_change(val){
        this.pageparm.currentPage=val
        //用户列表
        this.user_list()
      },
      //用户列表
      user_list(){
        let that=this
        that.$axios.get(that.publicAjax.extra_path+'/admin/user/list',{
          params:{
            page:that.pageparm.currentPage,
            limit:that.pageparm.pageSize,
            key:that.user_form.key,
            companyId:that.user_form.companyId,
            departmentId:that.user_form.departmentId,
            userStatus:that.user_form.userStatus
          }
        }).then(data=>{
          if(data.data.success==true){
            //获取当前用户按钮权限
            that.$axios({
              method:'get',
              url:that.publicAjax.extra_path+'/admin/user/permission'
            }).then(data=>{
              if(data.data.success==true){
                that.btn_permission=data.data.data
              }else{
                that.$message.error(data.data.message)
              }
            })
            that.listData=data.data.data.list
            that.pageparm.total=data.data.data.total
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //所属数据仓、仓库、货主二级联动
      dataWarehouseType_change(value){
        let that=this
        //用户货主
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehouseCustomer/fromSelect/auth/'+value
        }).then(data=>{
          if(data.data.success==true){
            that.customer_list=data.data.data
            if(that.add_or_edit!='add'){
              that.auth_form.customerIds=that.row_auth_now.customerIds
            }
          }else{
            // that.$message.error(data.data.message)
          }
        })
        //用户仓库
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehouse/fromSelect/auth/'+value
        }).then(data=>{
          if(data.data.success==true){
            that.wareHouse_list=data.data.data
            if(that.add_or_edit!='add'){
              that.auth_form.wareHouseIds=that.row_auth_now.wareHouseIds
            }
          }else{
            // that.$message.error(data.data.message)
          }
        })
      },
      //所属公司change事件
      company_change(value){
        let that=this
        //用户所属部门
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/dict/select/department/'+value
        }).then(data=>{
          if(data.data.success==true){
            that.department_list=data.data.data
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //查询用户列表
      search_list(){
        this.pageparm.currentPage=1
        this.pageparm.pageSize=10
        this.activeName='two'
        //用户列表
        this.user_list()
      },
      //重置用户列表查询表单
      reset_form(){
        this.$refs['user_form'].resetFields()
        this.pageparm.currentPage=1
        this.pageparm.pageSize=10
        //用户列表
        this.user_list()
      },
      //用户列表双击事件
      query_check_detail(row,column,event){
        this.activeName='three'
        //用户列表明细双击事件
        this.db_detail_list(row,column,event)
      },
      //用户列表明细双击事件
      db_detail_list(row,column,event){
        if(row==undefined){
          return false
        }
        this.user_id=row.id
        this.userName=row.userName
        this.nickName=row.nickName
        //选中当前行
        this.$refs.db_detail_list.setCurrentRow(row)
        //重置授权信息表单校验
        this.$refs.auth_form.clearValidate()
        //用户管理当前行数据
        this.row_query_now=row
        //获取授权信息列表
        this.get_auth_list()
      },
      //获取授权信息列表
      get_auth_list(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/user/auth/list/'+that.row_query_now.id
        }).then(data=>{
          if(data.data.success==true){
            that.author_data=data.data.data
            if(that.author_data.length==0){
              that.dataWarehouse_status=false
            }
            if(that.add_or_edit=='edit'){
              that.author_data.forEach(item=>{
                if(item.id==that.row_auth_now.id){
                  that.row_auth_now=item
                }
              })
              //授权信息列表双击事件
              that.db_author_list(that.row_auth_now)
            }else{
              //授权信息列表双击事件
              that.db_author_list(that.author_data[0])
            }
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //授权列表双击事件
      db_author_list(row,column,event){
        this.add_or_edit=''
        let that=this
        //用户授权表单禁用启用状态
        that.add_auth_status=false
        that.edit_auth_status=false
        that.delete_auth_status=false
        that.save_auth_status=true
        that.cancel_auth_status=true
        if(row==undefined){
          //重置授权信息表单
          this.$refs.auth_form.resetFields()
          return false
        }
        that.dataWarehouse_status=true
        //选中当前行
        that.$refs.db_author_list.setCurrentRow(row)
        //重置授权信息表单检验
        that.$refs.auth_form.clearValidate()
        //授权信息列表当前行数据
        that.row_auth_now=row
        //授权信息表单回显
        that.auth_form.dataWarehouseType=row.dataWarehouseType
        that.auth_form.companyId=row.companyId
        //公司二级联动部门
        that.company_change(row.companyId)
        //所属数据仓、仓库、货主二级联动
        that.dataWarehouseType_change(row.dataWarehouseType)

        that.auth_form.departmentId=row.departmentId
        that.auth_form.utype=row.utype
        that.auth_form.customerIds=row.customerIds
        that.auth_form.wareHouseIds=row.wareHouseIds
        that.auth_form.roleIds=row.roleIds
        that.auth_form.defaultUse=row.defaultUse
        that.auth_form.authStatus=row.authStatus
      },
      //新增授权信息前置
      add_auth(){
        let that=this
        //用户授权表单禁用启用状态
        that.dataWarehouse_status=false
        that.add_auth_status=true
        that.edit_auth_status=true
        that.delete_auth_status=true
        that.save_auth_status=false
        that.cancel_auth_status=false
        that.add_or_edit='add'
        //重置授权信息表单
        that.$refs.auth_form.resetFields()
      },
      //修改授权信息前置
      edit_auth(){
        let that=this
        //用户授权表单禁用启用状态
        that.dataWarehouse_status=true
        that.add_auth_status=true
        that.edit_auth_status=true
        that.delete_auth_status=true
        that.save_auth_status=false
        that.cancel_auth_status=false
        that.add_or_edit='edit'
        //重置表单校验
        that.$refs.auth_form.clearValidate()
      },
      //新增授权信息、修改授权信息(保存)
      save_auth(){
        let that=this
        that.$refs['auth_form'].validate((valid)=>{
          if(valid){
            if(that.add_or_edit=='add'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/admin/user/auth/'+that.auth_form.dataWarehouseType+'/'+that.user_id,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  companyId:that.auth_form.companyId,
                  departmentId:that.auth_form.departmentId,
                  utype:that.auth_form.utype,
                  customerIds:that.auth_form.customerIds,
                  wareHouseIds:that.auth_form.wareHouseIds,
                  roleIds:that.auth_form.roleIds,
                  defaultUse:that.auth_form.defaultUse,
                  authStatus:that.auth_form.authStatus
                }
              }).then(data=>{
                if(data.data.success==true){
                  //获取授权信息列表
                  that.get_auth_list()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.error(data.data.message)
                }
              })
            }else if(that.add_or_edit=='edit'){
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/admin/user/auth/'+that.row_auth_now.id+'/'+that.user_id,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  companyId:that.auth_form.companyId,
                  departmentId:that.auth_form.departmentId,
                  utype:that.auth_form.utype,
                  customerIds:that.auth_form.customerIds,
                  wareHouseIds:that.auth_form.wareHouseIds,
                  roleIds:that.auth_form.roleIds,
                  defaultUse:that.auth_form.defaultUse,
                  authStatus:that.auth_form.authStatus
                }
              }).then(data=>{
                if(data.data.success==true){
                  //获取授权信息列表
                  that.get_auth_list()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.error(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //用户取消操作
      reset_auth(){
        //用户列表明细双击事件
        this.db_detail_list(this.row_query_now)
      },
      //删除用户授权信息
      delete_auth(){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/admin/user/auth/'+that.row_auth_now.id+'/'+that.user_id
          }).then(data=>{
            if(data.data.success==true){
              //获取授权信息列表
              that.get_auth_list()
              that.$message.success(data.data.message)
            }else{
              that.$message.error(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //重置用户密码
      reset_password(row){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'put',
            url:that.publicAjax.extra_path+'/admin/user/resetPwd/'+row.id
          }).then(data=>{
            if(data.data.success==true){
              that.$message.success(data.data.message)
            }else{
              that.$message.error(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //启用或禁用用户
      open_close(row){
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          if(row.status==0){
            //启用用户
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/user/active/'+row.id
            }).then(data=>{
              if(data.data.success==true){
                //用户列表
                that.user_list()
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }else{
            //禁用用户
            that.$axios({
              method:'put',
              url:that.publicAjax.extra_path+'/admin/user/disable/'+row.id
            }).then(data=>{
              if(data.data.success==true){
                //用户列表
                that.user_list()
                that.$message.success(data.data.message)
              }else{
                that.$message.error(data.data.message)
              }
            })
          }
        }).catch(()=>{

        })
      }
    }
  }
</script>

<style scoped="scoped">
  .operate{
    margin-bottom: 2px;
    cursor: pointer;
  }
  .el_details_row{
    display: flex;
    justify-content: space-between;
  }
  .db_detail_list{
    width: 30%;
  }
  .detail_tabs{
    width: 67%;
    margin-left: 10px;
  }
  .user_form .el-select-dropdown{
    position: absolute !important;
     top: 30px !important;
     left: 0px !important;
     height: 100px !important;
  }
  .el-row .el-button{
    margin-bottom: 5px;
  }
  .el-button+.el-button{
    margin-left: auto;
  }
  .user_form .el-form-item,
  .auth_form .el-form-item{
    width: 49%;
    display: inline-block;
  }
  .user_form .el-form-item:last-child,
  .auth_form .el-form-item:last-child{
    width: 100%;
  }
  .auth_form{

  }
  @media screen and (max-width:720px){
    .user_form .el-form-item,
    .auth_form .el-form-item{
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/query.vue